import type { BlogPost } from "../types";
import future_fish_eurasia_2026_img from "@/assets/future-fish-eurasia-2026-cover.png";
import super_fresh_chlorella_sv12_from_japan_img from "@/assets/super-fresh-chlorella-sv12-from-japan-to-your-rotifer-tanks-cover.webp";
import sv12_kilic_case_study_img from "@/assets/products/sv12-image-edited.webp";
import ovaMacroImg from "@/assets/products/optimized/salmon-eyed-ova-macro-1024.webp";
import reviveDecapOpenImg from "@/assets/products/optimized/revive-artemia-decap-open-1024.webp";
import wheatGlutenFeed from "@/assets/optimized/wheat-gluten-feed-1024.webp";
import aegeanFishCages from "@/assets/optimized/aegean-fish-cages-1024.webp";
import fishMealImg from "@/assets/products/optimized/premium-fish-meal-1024.webp";

import beyond_the_brand_the_biological_reality_of_artemia_performance_in_turkiye_19_img from "@/assets/beyond-the-brand-the-biological-reality-of-artemia-performance-in-turkiye-19-cover.webp";
import overcoming_the_top_10_challenges_in_salmon_egg_sourcing_and_management_16_img from "@/assets/overcoming-the-top-10-challenges-in-salmon-egg-sourcing-and-management-16-cover.webp";
import fresh_chlorella_and_artemia_a_proven_combination_to_boost_rotifer_production_15_img from "@/assets/fresh-chlorella-and-artemia-a-proven-combination-to-boost-rotifer-production-15-cover.webp";
import vars_aquaculture_the_first_and_largest_supplier_of_salmon_eggs_in_south_korea_17_img from "@/assets/vars-aquaculture-the-first-and-largest-supplier-of-salmon-eggs-in-south-korea-17-cover.webp";
import fertilized_salmon_eggs_where_every_salmon_farming_journey_begins_13_img from "@/assets/fertilized-salmon-eggs-where-every-salmon-farming-journey-begins-13-cover.webp";
import the_role_of_wheat_gluten_in_aquaculture_14_img from "@/assets/the-role-of-wheat-gluten-in-aquaculture-14-cover.webp";
import dry_artemia_cyst_guide_boost_your_hatch_rate_larval_nutrition_12_img from "@/assets/dry-artemia-cyst-guide-boost-your-hatch-rate-larval-nutrition-12-cover.webp";
import our_journey_in_aquaculture_from_vision_to_industry_leader_in_live_feed_solutions_11_img from "@/assets/our-journey-in-aquaculture-from-vision-to-industry-leader-in-live-feed-solutions-11-cover.webp";
import rotifers_artemia_cornerstones_of_sustainable_aquaculture_nutrition_9_img from "@/assets/rotifers-artemia-cornerstones-of-sustainable-aquaculture-nutrition-9-cover.webp";
import live_feeds_in_hatcheries_aquariums_common_questions_and_expert_solutions_10_img from "@/assets/live-feeds-in-hatcheries-aquariums-common-questions-and-expert-solutions-10-cover.webp";
import unlock_the_full_power_of_potato_protein_meal_in_seabass_seabream_feeds_6_img from "@/assets/unlock-the-full-power-of-potato-protein-meal-in-seabass-seabream-feeds-6-cover.webp";
import moist_pellets_for_fish_superior_palatability_efficiency_easy_production_7_img from "@/assets/moist-pellets-for-fish-superior-palatability-efficiency-easy-production-7-cover.webp";
import chemical_vs_biochemical_elements_classification_and_essential_roles_in_life_8_img from "@/assets/chemical-vs-biochemical-elements-classification-and-essential-roles-in-life-8-cover.webp";
import understanding_eyed_salmon_eggs_survival_biosecurity_international_hatchery_supply_20_img from "@/assets/understanding-eyed-salmon-eggs-survival-biosecurity-international-hatchery-supply-20-cover.webp";
import unlocking_the_power_of_dried_artemia_feed_in_modern_aquaculture_4_img from "@/assets/unlocking-the-power-of-dried-artemia-feed-in-modern-aquaculture-4-cover.webp";
import vars_strengthens_global_presence_at_bexco_fair_in_south_korea_3_img from "@/assets/events/bisfe-2024/bisfe-2024-bexco-exterior.webp";
import olive_flounder_farming_1_img from "@/assets/olive-flounder-farming-1-cover.webp";
import aegean_region_klcdeniz_hatchery_trials_2_img from "@/assets/aegean-region-kılıcdeniz-hatchery-trials-2-cover.webp";

export const BLOG_POSTS: BlogPost[] = [
  {
    slug: "sv12-protocol-implementation-at-kilic-hatchery-with-japanese-experts",
    category: "Projects",
    categorySlug: "projects-4",
    title: "Case Study: Implementing SV12 Rotifer Protocol at Kılıç",
    excerpt:
      "In February 2019 the boxes from Chikugo arrived at the Kılıç hatchery — and so did the people who invented the protocol. What implementing SV12 with Chlorella Industry's Japanese engineers actually looked like, in photos.",
    body: "",
    author: "Vahid A.",
    authorInitials: "VA",
    date: "2026-08-12",
    readMinutes: 3,
    image: sv12_kilic_case_study_img,
  },
  {
    slug: "super-fresh-chlorella-sv12-from-japan-to-your-rotifer-tanks",
    category: "Feed Innovation & Microalgae",
    categorySlug: "feed-innovation-sustainability-8",
    title: "Super Fresh Chlorella SV12: Japan to Rotifer Tanks",
    excerpt:
      "What is actually inside a box of SV12, how it is grown at the Chikugo plant in Fukuoka, and the day-by-day feeding plan that takes a rotifer culture from 200 to 1,200 individuals per millilitre.",
    body: "",
    author: "Vahid A.",
    authorInitials: "VA",
    date: "2026-08-12",
    readMinutes: 5,
    image: super_fresh_chlorella_sv12_from_japan_img,
  },
  {
    slug: "vars-at-future-fish-eurasia-2026-izmir-stand-c237",
    category: "Company News",
    categorySlug: "vars-company-1",
    title: "VARS at Future Fish Eurasia 2026: Hall C, Stand C-237",
    excerpt:
      "24–26 September, Fuar İzmir. Three days in our own city, and an open invitation to bring us a specification rather than collect a brochure.",
    body: "",
    author: "Vahid A.",
    authorInitials: "VA",
    date: "2026-08-11",
    readMinutes: 3,
    image: future_fish_eurasia_2026_img,
  },
  {
    slug: "beyond-the-brand-the-biological-reality-of-artemia-performance-in-turkiye-19",
    category: "Feed Innovation & Microalgae",
    categorySlug: "feed-innovation-sustainability-8",
    title: "Biological Reality of Artemia Performance in Türkiye",
    excerpt: "A Proven Legacy: Revive Artemia in Türkiye (Turkey)",
    body: "",
    author: "Vahid A.",
    authorInitials: "VA",
    date: "2026-06-25",
    readMinutes: 4,
    image: beyond_the_brand_the_biological_reality_of_artemia_performance_in_turkiye_19_img,
  },
  {
    slug: "overcoming-the-top-10-challenges-in-salmon-egg-sourcing-and-management-16",
    category: "Aquaculture 101",
    categorySlug: "aquaculture-10",
    title: "Top 10 Challenges in Salmon Egg Sourcing & Management",
    excerpt:
      "Even for Tier-1 hatcheries, sourcing and managing [salmon eggs](/products/hatchery-solutions/atlantic-salmon-egg) (ova) is a high-stakes endeavor. In an industry where microscopic variables dictate million-dollar outcomes, securi...",
    body: "",
    author: "Reza R.",
    authorInitials: "RR",
    date: "2026-06-24",
    readMinutes: 3,
    image: overcoming_the_top_10_challenges_in_salmon_egg_sourcing_and_management_16_img,
  },
  {
    slug: "fresh-chlorella-and-artemia-a-proven-combination-to-boost-rotifer-production-15",
    category: "Feed Innovation & Microalgae",
    categorySlug: "feed-innovation-sustainability-8",
    title: "Fresh Chlorella SV-12: Boosting Rotifer Production",
    excerpt:
      "Every hatchery manager knows that rotifers are the backbone of larval rearing. Their density, nutritional value, and stability can significantly impact a hatchery cycle. Yet, ac...",
    body: "",
    author: "Vahid A.",
    authorInitials: "VA",
    date: "2026-06-23",
    readMinutes: 3,
    image: fresh_chlorella_and_artemia_a_proven_combination_to_boost_rotifer_production_15_img,
  },
  {
    slug: "vars-aquaculture-the-first-and-largest-supplier-of-salmon-eggs-in-south-korea-17",
    category: "Aquaculture 101",
    categorySlug: "aquaculture-10",
    title: "VARS: Leading Salmon Egg Supplier in South Korea",
    excerpt:
      "South Korea’s aquaculture sector has grown rapidly over the past decade, and [salmon eggs](/products/hatchery-solutions/atlantic-salmon-egg) have become one of the most critical inputs for hatcheries aiming for consistent, high-q...",
    body: "",
    author: "Reza R.",
    authorInitials: "RR",
    date: "2026-06-22",
    readMinutes: 3,
    image: vars_aquaculture_the_first_and_largest_supplier_of_salmon_eggs_in_south_korea_17_img,
  },
  {
    slug: "fertilized-salmon-eggs-where-every-salmon-farming-journey-begins-13",
    category: "Aquaculture 101",
    categorySlug: "aquaculture-10",
    title: "Fertilized Salmon Eggs: The Basis of Salmon Farming",
    excerpt:
      "Walk into a salmon hatchery in Norway, Scotland, or Chile and you’ll see the heart of aquaculture at work. In rows of incubation trays, millions of fertilized [salmon eggs](/products/hatchery-solutions/atlantic-salmon-egg) rest u...",
    body: "",
    author: "Reza R.",
    authorInitials: "RR",
    date: "2026-05-21",
    readMinutes: 3,
    image: fertilized_salmon_eggs_where_every_salmon_farming_journey_begins_13_img,
  },
  {
    slug: "the-role-of-wheat-gluten-in-aquaculture-14",
    category: "Feed Innovation & Microalgae",
    categorySlug: "feed-innovation-sustainability-8",
    title: "The Role of Wheat Gluten in Aquaculture",
    excerpt:
      "Aquaculture today is more than just farming fish — it is about feeding a growing world while balancing sustainability, efficiency, and profitability. For decades, fishmeal was t...",
    body: "",
    author: "Vahid A.",
    authorInitials: "VA",
    date: "2026-05-20",
    readMinutes: 4,
    image: the_role_of_wheat_gluten_in_aquaculture_14_img,
  },
  {
    slug: "dry-artemia-cyst-guide-boost-your-hatch-rate-larval-nutrition-12",
    category: "Hatchery Feed Design",
    categorySlug: "hatchery-feed-design-6",
    title: "Dry Artemia Cyst Guide: Hatch Rates & Larval Diet",
    excerpt:
      "Operational guide to dry Artemia cysts: cryptobiosis biology, 24-hour hatching parameters, 90%+ hatch rate troubleshooting, and HUFA enrichment protocols.",
    body: "",
    author: "Vahid A.",
    authorInitials: "VA",
    date: "2026-05-19",
    readMinutes: 7,
    image: dry_artemia_cyst_guide_boost_your_hatch_rate_larval_nutrition_12_img,
  },
  {
    slug: "our-journey-in-aquaculture-from-vision-to-industry-leader-in-live-feed-solutions-11",
    category: "Company News",
    categorySlug: "vars-company-1",
    title: "Our Journey: Leading Live Feed Solutions in Aquaculture",
    excerpt: "From a Biotech Vision to Industry Innovation",
    body: "",
    author: "Reza R.",
    authorInitials: "RR",
    date: "2026-05-18",
    readMinutes: 2,
    image: our_journey_in_aquaculture_from_vision_to_industry_leader_in_live_feed_solutions_11_img,
  },
  {
    slug: "rotifers-artemia-cornerstones-of-sustainable-aquaculture-nutrition-9",
    category: "Feed Innovation & Microalgae",
    categorySlug: "feed-innovation-sustainability-8",
    title: "Rotifers & Artemia: Cornerstones of Aquaculture Diet",
    excerpt:
      "Managing rotifer culture kinetics, Instar-I vs. Instar-II Artemia bioenergetics, and DHA/EPA/ARA bio-encapsulation for marine finfish larviculture.",
    body: "",
    author: "Vahid A.",
    authorInitials: "VA",
    date: "2026-04-17",
    readMinutes: 5,
    image: rotifers_artemia_cornerstones_of_sustainable_aquaculture_nutrition_9_img,
  },
  {
    slug: "live-feeds-in-hatcheries-aquariums-common-questions-and-expert-solutions-10",
    category: "Feed Innovation & Microalgae",
    categorySlug: "feed-innovation-sustainability-8",
    title: "Live Feeds in Hatcheries & Aquariums: Expert FAQ",
    excerpt: "1. Why Rotifers & Artemia Matter in Hatcheries",
    body: "",
    author: "Vahid A.",
    authorInitials: "VA",
    date: "2026-04-16",
    readMinutes: 2,
    image: live_feeds_in_hatcheries_aquariums_common_questions_and_expert_solutions_10_img,
  },
  {
    slug: "unlock-the-full-power-of-potato-protein-meal-in-seabass-seabream-feeds-6",
    category: "Feed Innovation & Microalgae",
    categorySlug: "feed-innovation-sustainability-8",
    title: "Potato Protein Meal in Seabass & Seabream Aquafeeds",
    excerpt:
      "Potato protein concentrate digests at 88.8% in vitro and can replace up to 20% of fish meal in seabass and seabream feeds. Trial evidence and the limits.",
    body: "",
    author: "Vahid A.",
    authorInitials: "VA",
    date: "2026-04-15",
    readMinutes: 2,
    image: unlock_the_full_power_of_potato_protein_meal_in_seabass_seabream_feeds_6_img,
  },
  {
    slug: "moist-pellets-for-fish-superior-palatability-efficiency-easy-production-7",
    category: "Feed Innovation & Microalgae",
    categorySlug: "feed-innovation-sustainability-8",
    title: "Moist Pellets for Fish: Palatability & Production",
    excerpt:
      "Formulation chemistry of moist pellets (20-35% moisture): cold-binding with vital wheat gluten, preserving heat-labile attractants, and on-site extrusion SOP.",
    body: "",
    author: "Vahid A.",
    authorInitials: "VA",
    date: "2026-04-14",
    readMinutes: 5,
    image: moist_pellets_for_fish_superior_palatability_efficiency_easy_production_7_img,
  },
  {
    slug: "chemical-vs-biochemical-elements-classification-and-essential-roles-in-life-8",
    category: "Feed Innovation & Microalgae",
    categorySlug: "feed-innovation-sustainability-8",
    title: "Chemical vs Biochemical Elements in Aquaculture",
    excerpt: "1. Chemical vs. Biochemical Elements",
    body: "",
    author: "Vahid A.",
    authorInitials: "VA",
    date: "2026-03-13",
    readMinutes: 3,
    image: chemical_vs_biochemical_elements_classification_and_essential_roles_in_life_8_img,
  },
  {
    slug: "understanding-eyed-salmon-eggs-survival-biosecurity-international-hatchery-supply-20",
    category: "Aquaculture 101",
    categorySlug: "aquaculture-10",
    title: "Eyed Salmon Eggs: Survival, Biosecurity & Sourcing",
    excerpt:
      "Why salmon eggs ship best at the eyed stage: embryo development, transport survival, biosecurity and certification, and what to require of a supplier.",
    body: "",
    author: "Reza R.",
    authorInitials: "RR",
    date: "2026-03-12",
    readMinutes: 4,
    image: understanding_eyed_salmon_eggs_survival_biosecurity_international_hatchery_supply_20_img,
  },
  {
    slug: "unlocking-the-power-of-dried-artemia-feed-in-modern-aquaculture-4",
    category: "Hatchery Feed Design",
    categorySlug: "hatchery-feed-design-6",
    title: "Dried Artemia Feed in Modern Hatchery Aquaculture",
    excerpt:
      "In the fast-evolving world of aquaculture, feed innovation is one of the most critical components of hatchery success. Among the most trusted and time-tested options for larval ...",
    body: "",
    author: "Vahid A.",
    authorInitials: "VA",
    date: "2026-03-11",
    readMinutes: 4,
    image: unlocking_the_power_of_dried_artemia_feed_in_modern_aquaculture_4_img,
  },
  {
    slug: "vars-strengthens-global-presence-at-bexco-fair-in-south-korea-3",
    category: "Company News",
    categorySlug: "vars-company-1",
    title: "VARS at BISFE 2024: Busan Seafood & Fisheries Expo",
    excerpt:
      "A verified look back at VARS Aquaculture's participation in BISFE 2024 in Busan, presenting Artemia cysts, salmon eggs, and fresh Chlorella.",
    body: "",
    author: "Reza R.",
    authorInitials: "RR",
    date: "2025-04-12",
    readMinutes: 2,
    image: vars_strengthens_global_presence_at_bexco_fair_in_south_korea_3_img,
    eventId: "bisfe",
  },
  {
    slug: "olive-flounder-farming-1",
    category: "Projects",
    categorySlug: "projects-4",
    title: "Olive Flounder Farming: RAS & Global Logistics",
    excerpt:
      "Comprehensive guide to Paralichthys olivaceus aquaculture: land-based RAS parameters, green-water weaning, and sashimi-grade live cold-chain transport.",
    body: "",
    author: "Vahid A.",
    authorInitials: "VA",
    date: "2026-02-09",
    readMinutes: 5,
    image: olive_flounder_farming_1_img,
  },
  {
    slug: "aegean-region-kılıcdeniz-hatchery-trials-2",
    category: "Projects",
    categorySlug: "projects-4",
    title: "Aegean KılıçDeniz Hatchery Trials: Live Feed Protocols",
    excerpt:
      "Technical field trial at KılıçDeniz: overcoming rotifer crash vulnerability, Super Fresh Chlorella V12 dosing protocols, and achieving an 8-fold density increase.",
    body: "",
    author: "Vahid A.",
    authorInitials: "VA",
    date: "2026-02-08",
    readMinutes: 5,
    image: aegean_region_klcdeniz_hatchery_trials_2_img,
  },
  {
    slug: "decapsulated-artemia-cysts-aquarium-fish-nutrition-guide",
    category: "Hatchery Feed & Design",
    categorySlug: "hatchery-feed-design-6",
    title: "Decapsulated Artemia for Fry: Selection & Preparation",
    excerpt:
      "Choosing between dried decapsulated Artemia and live nauplii: feed acceptance, preparation, hygiene and supplier specifications.",
    body: "",
    author: "Technical Services",
    authorInitials: "TS",
    date: "2026-09-05",
    updated: "2026-09-09",
    readMinutes: 3,
    image: reviveDecapOpenImg,
  },
  {
    slug: "salmon-ova-hatching-accumulated-thermal-units-guide",
    category: "Aquaculture",
    categorySlug: "aquaculture-10",
    title: "Salmon Egg Incubation: Degree-Days and Hatchery Planning",
    excerpt:
      "Using accumulated temperature alongside supplier guidance to plan egg incubation, water monitoring, receiving and first feeding.",
    body: "",
    author: "Technical Services",
    authorInitials: "TS",
    date: "2026-09-05",
    updated: "2026-09-09",
    readMinutes: 3,
    image: ovaMacroImg,
  },
  {
    slug: "brown-meagre-aquaculture-grow-out-culinary-guide",
    category: "Projects & Field Trials",
    categorySlug: "projects-4",
    title: "Meagre: Species ID, Farming and Buyer Specifications",
    excerpt:
      "Distinguishing Argyrosomus regius from Sciaena umbra and specifying farmed meagre for processing, kitchens and export.",
    body: "",
    author: "Technical Services",
    authorInitials: "TS",
    date: "2026-09-05",
    updated: "2026-09-09",
    readMinutes: 3,
    image: aegeanFishCages,
  },
  {
    slug: "vital-wheat-gluten-aquafeed-extrusion-binding-chemistry",
    category: "Feed Innovation & Sustainability",
    categorySlug: "feed-innovation-sustainability-8",
    title: "Vital Wheat Gluten in Aquafeed: Binding & Formulation",
    excerpt:
      "Evaluating gluten functionality, extrusion conditions, pellet stability and nutritional balance without universal performance claims.",
    body: "",
    author: "Technical Services",
    authorInitials: "TS",
    date: "2026-09-05",
    updated: "2026-09-09",
    readMinutes: 3,
    image: wheatGlutenFeed,
  },
  {
    slug: "fish-meal-quality-grading-tvn-hatchery-nutrition",
    category: "Hatchery Feed & Design",
    categorySlug: "hatchery-feed-design-6",
    title: "Fish Meal Quality: Processing, Analysis and Buyer Checks",
    excerpt:
      "Assessing fish meal through batch evidence, analytical methods, processing history and suitability for the intended feed.",
    body: "",
    author: "Technical Services",
    authorInitials: "TS",
    date: "2026-09-05",
    updated: "2026-09-09",
    readMinutes: 3,
    image: fishMealImg,
  },
];

import type { LangCode } from "../types";

export function getLocalizedPost(post: BlogPost, lang: LangCode): BlogPost {
  if (!post) return post;
  const translation = post.translations?.[lang];
  if (!translation) return post;
  return {
    ...post,
    title: translation.title || post.title,
    excerpt: translation.excerpt || post.excerpt,
    body: translation.body || post.body,
    category: translation.category || post.category,
  };
}

export function getLocalizedPosts(lang: LangCode): BlogPost[] {
  return BLOG_POSTS.map((post) => getLocalizedPost(post, lang));
}

export function getPost(slug: string, lang?: LangCode): BlogPost | undefined {
  const post = BLOG_POSTS.find((p) => p.slug === slug);
  if (!post) return undefined;
  if (lang) return getLocalizedPost(post, lang);
  return post;
}

export function getPostsByCategory(categorySlug: string, lang?: LangCode): BlogPost[] {
  const posts = BLOG_POSTS.filter((p) => p.categorySlug === categorySlug);
  if (lang) return posts.map((p) => getLocalizedPost(p, lang));
  return posts;
}

import { BLOG_TRANSLATIONS } from "./blog_translations";
import { loadBlogBodies } from "./blog_bodies";

// Titles, excerpts and category names only — 60 KB, and every surface that
// lists articles needs them synchronously (BlogWidget on the home page has no
// loader to await in). Bodies are ~984 KB and are merged in per locale by
// withLocalizedBody() below, which is what keeps them off every page that only
// shows headlines. A locale with a translated title but no body yet renders the
// translated heading over the English body, exactly as before.
BLOG_POSTS.forEach((post) => {
  // Derive reading time from body length (~200 words per minute), bounded at minimum 1 minute.
  if (post.body) {
    const words = post.body.trim().split(/\s+/).length;
    post.readMinutes = Math.max(1, Math.ceil(words / 200));
  }
  const meta = BLOG_TRANSLATIONS[post.slug];
  if (!meta) return;
  const merged: NonNullable<BlogPost["translations"]> = {};
  for (const [lang, entry] of Object.entries(meta) as [
    LangCode,
    NonNullable<BlogPost["translations"]>[LangCode],
  ][]) {
    if (!entry) continue;
    merged[lang] = entry;
  }
  post.translations = merged;
});

/**
 * One article, localized, including its body.
 *
 * The await is why the article route's loader is async. Loader data is what the
 * component renders from and what gets serialized for hydration, so the body
 * never has to be re-resolved on the client — no module-state read at render
 * time, and therefore no hydration mismatch when the client has not loaded that
 * locale's bodies yet.
 */
export async function loadLocalizedPost(
  slug: string,
  lang: LangCode,
): Promise<BlogPost | undefined> {
  const post = getPost(slug, lang);
  if (!post) return undefined;
  const bodies = await loadBlogBodies(lang);
  let body = bodies[slug];
  if (!body && lang !== "en") {
    const enBodies = await loadBlogBodies("en");
    body = enBodies[slug];
  }
  return body ? { ...post, body } : post;
}
